import { fmtDate, today } from '../../lib/format';

// Absender wie in der App (dieselbe Liste wie auf dem Server). Krankenkasse, Rentenversicherung und
// Berufsgenossenschaft gehören zur Lohnbuchhaltung, alles andere zur FiBu.
export const SENDERS = [
  'Finanzamt',
  'Krankenkasse',
  'Rentenversicherung',
  'Berufsgenossenschaft',
  'Stadt / Gemeinde',
  'Bank',
  'Sonstige',
] as const;
const LOHN_SENDERS = new Set(['Krankenkasse', 'Rentenversicherung', 'Berufsgenossenschaft']);
export const senderArea = (s: string) => (LOHN_SENDERS.has(s) ? 'lohn' : 'fibu');
export const AREA_LABEL = { fibu: 'FiBu', lohn: 'Lohn' } as const;

export const letterPath = (clientId: string, letterId: string) => `/kanzlei/mandanten/${clientId}/briefe?brief=${letterId}`;

// Frist aus dem Brief mit Tagen bis dahin: rot ab einer Woche, sonst grau
export function duePill(due: string): { tone: string; label: string; when: string } {
  const t = today();
  const [y, m, d] = due.split('-').map(Number);
  const n = Math.round((Date.UTC(y!, m! - 1, d!) - Date.UTC(t.year, t.month - 1, t.day)) / 86400000);
  const when =
    n < 0 ? `seit ${-n} ${n === -1 ? 'Tag' : 'Tagen'} vorbei` : n === 0 ? 'heute' : n === 1 ? 'morgen' : `in ${n} Tagen`;
  return { tone: n <= 7 ? 'bad' : 'neu', label: `Frist ${fmtDate(due)} (${when})`, when };
}
